import { Button, Loading, Modal, Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { driverProfileApi } from "@/redux/apis";
import { useUpdateFleetStatusMutation } from "@/redux/apis/driver/driverApi";
import { useAppDispatch } from "@/redux/hooks";
import { addToast } from "@/utils";
import { useProfileContext } from "../context";

interface UnsuspendDriverModalProps {
  open: boolean;
  onClose: () => void;
}

export const UnsuspendDriverModal = ({ open, onClose }: UnsuspendDriverModalProps) => {
  const dispatch = useAppDispatch();
  const { driver } = useProfileContext();
  const [updateFleetStatus, { isLoading }] = useUpdateFleetStatusMutation();

  const updateStatus = () => {
    updateFleetStatus({ id: driver.uuid, account_status: "active" })
      .unwrap()
      .then(() => {
        dispatch(driverProfileApi.util.invalidateTags(["DriverProfile"]));
        addToast("success", "Successfully unsuspended driver.");
        onClose();
      })
      .catch((e) => getErrorMessages(e).forEach((m) => addToast("danger", m)));
  };

  return (
    <Modal open={open} onClose={() => (isLoading ? null : onClose())} className="relative w-[80vw] !p-5 md:w-[514px] lg:w-[514px]">
      {isLoading && <Loading />}
      <Typography variant="title">Unsuspend Driver</Typography>
      <Typography variant="paragraph" className="mt-3">
        Unsuspending this driver will restore their access to the driver app. They&apos;ll be able to take jobs again once unsuspended.
      </Typography>
      <div className="mt-[22px] flex flex-row items-center justify-end gap-x-4">
        <Button size="md" variant="secondary" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button size="md" variant="primary" onClick={updateStatus} disabled={isLoading}>
          Unsuspend Driver
        </Button>
      </div>
    </Modal>
  );
};
